// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"FooterTcA_TheComp__J1PP7"};